import { useEffect } from 'react';
import Stack from '@mui/joy/Stack';


import { SupportButton, SupportUserSearch } from 'components/HomeSupportSection';
import LockedFeature from 'components/LockedFeature';
import CollabInviteAvailableList from 'components/CollabInviteAvailableList';

//import useUserIdentity from 'hooks/useUserIdentity';
import useRoles from 'hooks/useRoles';

const ManagerHome = () => {
    const { rolesNames } = useRoles();
    useEffect(() => {
        document.title = "Manager Home";
    }, []);

    return (
        <Stack spacing={3}>
            <Stack spacing={1}
                direction={{ xs: 'column', sm: "row" }}
            >
                <LockedFeature
                    lockedIconName="PersonSearchOutlined"
                    unlockedIconName="PersonSearch"
                    copy="User Search">
                    <SupportUserSearch />
                </LockedFeature>
            </Stack>
            <Stack spacing={1}
                direction={{ xs: 'column', sm: "row" }}
            >
                {rolesNames.includes('manager') &&
                    <>
                        <SupportButton
                            color="warning"
                            iconName="ContactsOutlined"
                            to="/manager/identities"
                            title="View Identities"
                        />
                        <SupportButton
                            color="warning"
                            iconName="ContactsOutlined"
                            to="/manager/user-create"
                            title="Create User"
                        />
                    </>
                }

            </Stack>

                {rolesNames.includes('sudo') &&
                    <Stack direction="row">
                    <SupportButton
                        color="danger"
                        iconName="Key"
                        to="/manager/redis"
                        title="Redis Admin"
                    />

                    </Stack>
                }
            <CollabInviteAvailableList variant="support" paged={false} />
        </Stack>

    );
}

export default ManagerHome;
